export const environment = {
  production: true,
  backEndUrl: 'https://test.myevents.costa.it/api',
};
